import React, { createContext, useState, useContext, ReactNode } from 'react';
import { saveSession, loadSession, clearSession } from '../utils/sessionManager';
// Definimos la forma que tendrán los datos del usuario
interface AuthData {
  username: string | null;
  token: string | null;
  role: string | null;
  daysRemaining: number | null;
}

// Definimos el tipo del contexto
interface AuthContextType {
  authData: AuthData;
  login: (data: any) => void;
  logout: () => void;
  isAuthenticated: boolean;
}

// Creamos el contexto con un valor por defecto
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// --- El Proveedor del Contexto ---
export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [authData, setAuthData] = useState<AuthData>(() => {
    // 2. Usamos loadSession() para cargar los datos específicos del subdominio
    return loadSession();
  });
  
  const isAuthenticated = !!authData.token;

  const login = (data: any) => {
    saveSession(data);
    // Calcular la diferencia de días
    // Actualizar el estado del contexto
    setAuthData(loadSession());
  };

  const logout = () => {
    // Limpiar localStorage
    clearSession();
    
    // Resetear el estado
    setAuthData({ token: null, username: null, role: null, daysRemaining: null });
  };

  return (
    <AuthContext.Provider value={{ authData, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

// --- Hook personalizado para usar el contexto fácilmente ---
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};